const DOMAIN = 'https://phoenixunitydesigns.com';

export const SEO_CONFIG = {
  home: {
    title: 'Phoenix Unity Designs - Professional Web Design & Development in Ottawa',
    description: /*'Award-winning web design and development studio in Ottawa.' + */ 'We create beautiful, functional websites that help businesses grow. 15+ years of experience.',
    keywords: 'web design Ottawa, web development Ottawa, website design, professional web design, Ottawa web agency',
    path: '/',
  },
  work: {
    title: 'Our Work | Phoenix Unity Designs',
    description: 'Explore our portfolio of custom web design and development projects. See how we\'ve helped brands like Time For You, West Side Pride, and Claridge Plaza 3.',
    keywords: 'portfolio, web design projects, web development examples, case studies',
    path: '/work',
  },
  project: (brand) => ({
    title: `${brand} | Phoenix Unity Designs`,
    description: `Discover how Phoenix Unity Designs created a stunning website for ${brand}. Custom web design and development tailored to unique business needs.`,
    keywords: `web design, web development, ${brand}, branding`,
    path: '/project/:id',
  }),
  ourProcess: {
    title: 'Our Process | Phoenix Unity Designs',
    description: 'Understand how Phoenix Unity Designs works with clients. From initial consultation to ongoing maintenance, we guide you through every step of the web development process.',
    keywords: 'web development process, web design process, how we work, web design methodology',
    path: '/our-process',
  },
  about: {
    title: 'About Phoenix Unity Designs',
    description: 'Woman-owned Ottawa web design studio committed to quality and community. We create inclusive, accessible websites that make an impact.',
    keywords: 'about Phoenix Unity Designs, woman-owned business, Ottawa design studio',
    path: '/about',
  },
  contact: {
    title: 'Contact Phoenix Unity Designs',
    description: 'Ready to start your web project? Get in touch with Phoenix Unity Designs in Ottawa. We\'d love to hear about your vision.',
    keywords: 'contact web designer, Ottawa web design services, get a quote',
    path: '/contact',
  },
  privacyPolicy: {
    title: 'Privacy Policy | Phoenix Unity Designs',
    description: 'Learn how Phoenix Unity Designs handles your data. We respect your privacy and only collect necessary information through Google Analytics.',
    keywords: 'privacy policy, data protection',
    path: '/privacy-policy',
  },
  notFound: {
    title: '404 - Page Not Found | Phoenix Unity Designs',
    description: 'The page you\'re looking for doesn\'t exist. Return to Phoenix Unity Designs to explore our services and portfolio.',
    keywords: '404',
    path: '/404',
  },
};

export const DEFAULT_SEO = {
  title: 'Phoenix Unity Designs - Professional Web Design & Development in Ottawa',
  description: /* 'Award-winning web design and development studio in Ottawa.' + */ 'We create beautiful, functional websites that help businesses grow. 15+ years of experience.',
  keywords: 'web design Ottawa, web development Ottawa, website design, professional web design, Ottawa web agency',
  ogImage: `${DOMAIN}/phoenix-unity-designs-dark.svg`,
  ogType: 'website',
  // twitterHandle: '@phoenixunitydesigns',
};

export const DOMAIN_URL = DOMAIN;

/**
 * Helper function to get full canonical URL
 */
export const getCanonicalUrl = (path) => {
  return `${DOMAIN}${path}`;
};

/**
 * Helper function to create JSON-LD structured data
 */
export const getOrganizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Phoenix Unity Designs',
  url: DOMAIN,
  logo: `${DOMAIN}/phoenix-unity-designs-dark.svg`,
  description: 'Award-winning web design and development studio in Ottawa',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Ottawa',
    addressRegion: 'ON',
    addressCountry: 'CA',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: 'info@phoenixunitydesigns.com',
    contactType: 'Customer Service',
  },
  // sameAs: [
  //   'https://www.facebook.com/phoenixunitydesigns',
  //   'https://www.instagram.com/phoenixunitydesigns',
  //   'https://www.linkedin.com/company/phoenix-unity-designs',
  // ],
});

/**
 * Helper function to create JSON-LD structured data for LocalBusiness
 */
export const getLocalBusinessSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'Phoenix Unity Designs',
  image: `${DOMAIN}/phoenix-unity-designs-dark.svg`,
  description: 'Professional web design and development studio',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Ottawa',
    addressRegion: 'Ontario',
    addressCountry: 'CA',
  },
  url: DOMAIN,
  telephone: 'info@phoenixunitydesigns.com',
  priceRange: '$$',
});
